export enum EventType {
  // Pager Event
  REFRESH_PAGER_ICON,

  // Dialog
  SHOW_AGREEMENT_DIALOG,
  CLOSE_AGREEMENT_DIALOG,
  SHOW_QUIZ_DIALOG,
  CLOSE_QUIZ_DIALOG,

  // Http Client
  RECIEVE_SUCCESSFULLY_RESPONSE,
  RECIEVE_ERROR_RESPONSE,
  RECIEVE_POST_RESPONSE,
  RECIEVE_UPLOAD_RESPONSE,
}



// WEBPACK FOOTER //
// /Users/mizunoe_jing/Documents/nice_day_current/bitbucket/starbright/src/app/enum/event-type.ts